var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-detail-settings-cols", {
            attrs: { settings: _vm.layout, "full-control": _vm.fullControl },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-detail-settings-image", {
            attrs: {
              settings: _vm.layout.DetailBeforeImage,
              title: _vm.$ct("detail-before-image"),
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-detail-settings-image", {
            attrs: {
              settings: _vm.layout.DetailAfterImage,
              title: _vm.$ct("detail-after-image"),
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { style: { flexDirection: "row" }, attrs: { xs: "12" } },
        [
          _c(
            "w-button",
            {
              staticClass: "cancel mt",
              on: {
                click: function ($event) {
                  return _vm.reset()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("reset-to-defaults")) + " ")]
          ),
          _c("w-spacer"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }